export default __webpack_public_path__ + "static/media/shaped-wordclouds-poster.0892309b.pdf";